import { triggerHaptic } from "@/lib/nativeHaptics";

interface Props {
  onTap: () => void;
}

const INK = "#2C2820";
const CREAM = "#FAECE7";
const CORAL = "#C84B2F";
const MUTED_CREAM = "rgba(250, 236, 231, 0.72)";

const ctaBtn: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  background: CORAL,
  color: "#FFFFFF",
  borderRadius: 22,
  padding: "10px 20px",
  fontSize: 15,
  fontWeight: 600,
  border: "none",
  cursor: "pointer",
  marginTop: 14,
  minHeight: 44,
};

export default function PersonalisationUpsellCard({ onTap }: Props) {
  return (
    <section
      aria-label="See yourself in every look"
      style={{
        background: INK,
        color: "#FFFFFF",
        border: `1.5px solid ${CORAL}`,
        borderRadius: 20,
        margin: "16px 16px 0",
        padding: 18,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <i
        className="ti ti-sparkles"
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 14,
          right: 14,
          fontSize: 20,
          color: CORAL,
        }}
      />
      <div
        aria-hidden="true"
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: CREAM,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 12,
        }}
      >
        <i className="ti ti-user-circle" style={{ fontSize: 28, color: INK }} />
      </div>
      <div
        className="l2f-type-section-header"
        style={{ color: CORAL, letterSpacing: "0.08em" }}
      >
        PERSONALISE
      </div>
      <div
        style={{
          fontSize: 17,
          fontWeight: 600,
          color: "#FFFFFF",
          marginTop: 4,
          letterSpacing: "-0.01em",
        }}
      >
        See yourself in every look
      </div>
      <div
        className="l2f-type-caption"
        style={{ color: MUTED_CREAM, lineHeight: 1.5, marginTop: 6 }}
      >
        Add a selfie so your lookbook models look like you.
      </div>
      <button
        type="button"
        style={ctaBtn}
        onClick={() => {
          void triggerHaptic("primary-action");
          onTap();
        }}
      >
        <i className="ti ti-camera" style={{ fontSize: 16 }} aria-hidden="true" />
        Add selfie
      </button>
    </section>
  );
}
